var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPittoErrGen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 180,
    viewBox: "0 0 216 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0251 90C22.0251 40.294 62.3191 0 112.025 0C161.731 0 202.025 40.294 202.025 90C202.025 139.706 161.731 180 112.025 180C62.3191 180 22.0251 139.706 22.0251 90",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.505 136.69L41.4653 151.804C39.5943 151.991 37.9263 150.626 37.7383 148.755L27.5423 46.8577C27.3553 44.9867 28.7203 43.3177 30.5913 43.1307L181.631 28.0167C183.502 27.8297 185.171 29.1947 185.358 31.0657L195.554 132.963C195.741 134.834 194.376 136.503 192.505 136.69Z",
    fill: "#C8C8C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0329 149.531C40.9369 149.641 39.9599 148.841 39.8499 147.745L30.5769 55.0749L184.012 39.7219L193.285 132.392C193.395 133.488 192.595 134.465 191.499 134.575L42.0329 149.531Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8672 116.417L135.692 112.408L135.344 108.423L89.5186 112.432L89.8672 116.417Z",
    fill: "#595967"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6587 49.6224C48.7157 49.5164 49.5907 48.5554 49.4757 47.4014C49.3597 46.2484 48.4087 45.4694 47.2547 45.5844C46.1977 45.6904 45.3227 46.6524 45.4377 47.8054C45.5537 48.9594 46.6017 49.7284 47.6587 49.6224Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.0371 50.285C42.0941 50.179 42.9691 49.218 42.8541 48.064C42.7381 46.911 41.7871 46.132 40.6331 46.247C39.5761 46.353 38.7011 47.315 38.8161 48.468C38.9321 49.622 39.8831 50.4 41.0371 50.285Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4153 50.9476C35.4723 50.8416 36.3473 49.8806 36.2323 48.7266C36.1163 47.5736 35.1653 46.7946 34.0113 46.9096C32.9543 47.0156 32.0793 47.9776 32.1943 49.1306C32.3103 50.2846 33.3583 51.0536 34.4153 50.9476Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.45 46.3279L86.448 49.6299L92.435 39.8079L111.635 37.8869L119.45 46.3279Z",
    fill: "#EFEFEF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5801 49.0152L56.5781 52.3172L62.5651 42.4952L81.7651 40.5742L89.5801 49.0152Z",
    fill: "#EFEFEF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.195 51.5461L31.76 66.9001L30.561 54.9211L183.996 39.5671L185.195 51.5461Z",
    fill: "#EFEFEF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.345 48.4041L33.9313 63.2551L33.3713 57.6641L181.786 42.8131L182.345 48.4041Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7293 120.702C17.6373 120.702 17.5453 120.677 17.4633 120.625L7.72532 114.508C7.49132 114.361 7.42032 114.053 7.56732 113.819C7.71732 113.585 8.02732 113.517 8.25632 113.661L17.9953 119.779C18.2293 119.926 18.2993 120.234 18.1533 120.468C18.0573 120.619 17.8953 120.702 17.7293 120.702Z",
    fill: "#C4C4C8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80167 122.512C9.70967 122.512 9.61767 122.487 9.53567 122.435C9.30167 122.288 9.23167 121.98 9.37767 121.746L15.4947 112.008C15.6447 111.773 15.9557 111.705 16.1847 111.85C16.4187 111.997 16.4887 112.306 16.3427 112.54L10.2257 122.278C10.1297 122.429 9.96767 122.512 9.80167 122.512Z",
    fill: "#C4C4C8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5018 46.9409C16.3128 46.9409 16.1208 46.9519 15.9288 46.9759C14.6788 47.1279 13.5638 47.7579 12.7878 48.7489C12.0118 49.7399 11.6678 50.9739 11.8198 52.2239C11.9728 53.4729 12.6028 54.5889 13.5938 55.3649C14.5838 56.1409 15.8238 56.4849 17.0678 56.3319C19.6478 56.0179 21.4898 53.6639 21.1768 51.0839C20.8858 48.6969 18.8478 46.9409 16.5018 46.9409ZM16.4868 57.3669C15.2178 57.3669 13.9918 56.9469 12.9778 56.1519C11.7748 55.2119 11.0128 53.8589 10.8278 52.3449C10.6438 50.8299 11.0598 49.3339 11.9998 48.1319C12.9398 46.9309 14.2928 46.1679 15.8078 45.9829C18.9398 45.5969 21.7878 47.8359 22.1688 50.9629C22.5498 54.0899 20.3148 56.9429 17.1888 57.3239C16.9538 57.3529 16.7198 57.3669 16.4868 57.3669Z",
    fill: "#C4C4C8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16384 96.0691C0.861842 96.1811 -0.103158 97.3271 0.0088423 98.6291C0.120842 99.9311 1.26684 100.896 2.56884 100.784C3.87084 100.672 4.83584 99.5261 4.72384 98.2241C4.61184 96.9221 3.46584 95.9571 2.16384 96.0691Z",
    fill: "#9B9BA4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.971 149.217C198.154 149.217 196.332 149.876 194.901 151.208C193.444 152.563 192.602 154.404 192.53 156.392C192.458 158.381 193.164 160.278 194.52 161.735C195.874 163.191 197.715 164.033 199.703 164.105C201.712 164.184 203.589 163.47 205.045 162.115C208.053 159.318 208.224 154.596 205.427 151.589C203.962 150.014 201.968 149.217 199.971 149.217ZM199.981 165.11C199.876 165.11 199.772 165.108 199.667 165.104C197.412 165.023 195.325 164.068 193.787 162.415C192.25 160.763 191.449 158.611 191.531 156.356C191.613 154.101 192.567 152.013 194.219 150.476C197.63 147.304 202.987 147.497 206.159 150.907C209.331 154.319 209.138 159.675 205.727 162.847C204.151 164.313 202.121 165.11 199.981 165.11Z",
    fill: "#C4C4C8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.5 96.2712C214.54 97.9342 213.236 99.2682 211.586 99.2502C209.936 99.2322 208.566 97.8692 208.526 96.2062C208.485 94.5432 209.79 93.2102 211.44 93.2272C213.089 93.2452 214.46 94.6082 214.5 96.2712Z",
    fill: "#9B9BA4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.162 123.105C209.146 123.105 209.132 123.105 209.116 123.103C208.842 123.079 208.639 122.835 208.663 122.561L209.581 112.292C209.605 112.016 209.844 111.811 210.124 111.838C210.398 111.862 210.601 112.105 210.577 112.38L209.659 122.649C209.636 122.909 209.418 123.105 209.162 123.105Z",
    fill: "#C4C4C8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.756 118.43C214.74 118.43 214.726 118.43 214.71 118.428L204.441 117.509C204.166 117.485 203.963 117.242 203.987 116.967C204.012 116.69 204.244 116.485 204.53 116.513L214.8 117.432C215.074 117.456 215.277 117.7 215.253 117.974C215.23 118.235 215.012 118.43 214.756 118.43Z",
    fill: "#C4C4C8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.054 88.6803L137.92 88.0795L137.269 80.6445L130.403 81.2453L131.054 88.6803Z",
    fill: "#595967"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.2325 92.8641L90.1063 92.2627L89.4558 84.8277L82.5821 85.4291L83.2325 92.8641Z",
    fill: "#595967"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPittoErrGen);
export default __webpack_public_path__ + "static/media/Pitto_ErrGen.b586e31e7ce7aeeef572dce0cd74cd11.svg";
export { ForwardRef as ReactComponent };